import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

import { environment } from '@env/environment';
import { Button } from '@shared/components';

interface Scene {
  title: string;
  author: string;
  image: string;
  alt: string;
  link: string;
}

@Component({
  selector: 'app-any-image-works',
  templateUrl: './any-image-works.html',
  styleUrl: './any-image-works.scss',
  imports: [Button, NgOptimizedImage],
})
export class AnyImageWorks {
  readonly scenes: Scene[] = [
    {
      title: 'Boxes',
      author: 'Brandon Vietti',
      image: '/assets/demo/brandon.png',
      alt: 'A corner office scene built in EVRN',
      link: `${environment.appUrl}/view/scenes/6a8c9f152b6809db35226183`,
    },
    {
      title: 'Streets of Paracho',
      author: 'Vinod Kumar',
      image: '/assets/demo/vinod-exterior.png',
      alt: 'A village street scene built in EVRN',
      link: `${environment.appUrl}/view/scenes/6a8c9e532b6809db352260c8`,
    },
  ];
}
